import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem, buttonClassName } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const SamplePurchase: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([24, 0, 4, 0]),
    [theme.screen.tablet]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: theme.siteVariables.fontSizes['caption02'],
        color: '#7b7b7b',
        width: pxToRem(896),
        borderBottom: `${pxToRem(2)} solid ${
            theme.siteVariables.colors.grey[125]
        }`,
        padding: 0,
        minHeight: pxToRem(212),
    },
});

export const ShippingGroup: StyleRule = ({ theme }) => ({
    paddingBottom: theme.siteVariables.spaces['space-24'],
    [theme.screen.tablet]: {
        paddingBottom: 0,
    },
});

export const OrderGroup: StyleRule = ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: `1fr ${pxToRem(48)}`,
    alignSelf: 'center',
    [theme.screen.tablet]: {
        gridTemplateColumns: `1fr ${pxToRem(62)}`,
        fontSize: pxToRem(22),
        minHeight: pxToRem(64),
        lineHeight: '100%',
    },
});

export const OrderSample: StyleRule = () => ({
    textTransform: 'uppercase',
    minWidth: pxToRem(245),
});

export const OrderSampleButtonMobile: StyleRule = () => ({
    height: pxToRem(48),
    backgroundColor: '#222222',
    [`&.${buttonClassName} .${svgIconClassName}`]: {
        width: pxToRem(36),
        height: pxToRem(36),
    },
});
